import { rest } from 'msw'

export default [
  /**
   * ルート階層一覧
   */
  rest.get('/swc-api/master/root-nodes', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json([
        {
          id: 1,
          name: '排水処理 MBR',
          image: '',
          node_order: '1'
        }
      ])
    )
  }),

  /**
   * 階層簡易情報
   */
  rest.get('/swc-api/master/simple-nodes', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json([
        {
          id: 1,
          name: '排水処理 MBR',
          node_order: '1',
          is_auth: true,
          is_data: true,
          facility_group_code: 'MBR',
          facility_group_name: 'MBR',
          children_detail: []
        }
      ])
    )
  }),

  /**
   * 設備グループ情報
   */
   rest.get('/swc-api/master/node-groups', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([
        {
            "code": "MBR",
            "name": "MBR"
        },
        {
            "code": "RO",
            "name": "RO"
        },
        {
            "code": "SaiForce",
            "name": "SaiForce"
        }
    ]),
    )
  }),
  /**
   * 設備情報
   */
  rest.get('/swc-api/master/nodes', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([
        {
            "id": 1,
            "name": "排水処理 MBR",
            "image": "",
            "specification": null,
            "construction_memo": null,
            "organization_code": "2",
            "organization_name": "C 社",
            "facility_group_code": "MBR",
            "facility_group_name": "MBR",
            "plant_id": 1,
            "plant_name": "排水処理",
            "dashboard_settings": `[
              {
                "dashboard_id": "XXXX01",
                "dashboard_name": "流量",
                "graphs": [
                  {
                    "name": "001 RO ユニット流量 m/s",
                    "dataset_id": "test-001",
                    "units": [
                      {
                        "name": "℃",
                        "min": 25,
                        "max": 75
                      },
                      {
                        "name": "bit",
                        "min": 0,
                        "max": 1
                      }
                    ],
                    "fields": [
                      {
                        "dataset": "pw_uji_01",
                        "field": "field-name-A",
                        "color": "red"
                      },
                      {
                        "dataset": "pw_uji_01",
                        "field": "field-name-B",
                        "color": "blue"
                      },
                      {
                        "dataset": "pw_uji_01",
                        "field": "field-name-C",
                        "color": "green"
                      },
                      {
                        "dataset": "pw_uji_01",
                        "field": "P1KAV03",
                        "color": "green"
                      },
                      {
                        "dataset": "pw_uji_01",
                        "field": "bit_field01",
                        "color": "green"
                      },
                      {
                        "dataset": "pw_uji_01",
                        "field": "bit_field02",
                        "color": "green"
                      }
                    ]
                  },
                  {
                    "name": "濃縮水移送流量計",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {
                        "dataset": "pw_uji_01",
                        "field": "field-name-A",
                        "color": "red"
                      },
                      {
                        "dataset": "pw_uji_01",
                        "field": "field-name-B",
                        "color": "blue"
                      },
                      {
                        "dataset": "pw_uji_01",
                        "field": "field-name-C",
                        "color": "green"
                      },
                      {
                        "dataset": "pw_uji_01",
                        "field": "P1KAV02",
                        "color": "green"
                      },
                      {
                        "dataset": "pw_uji_01",
                        "field": "P1KAV01",
                        "color": "green"
                      },
                      {
                        "dataset": "pw_uji_01",
                        "field": "P1KAV03",
                        "color": "green"
                      },
                      {
                        "dataset": "pw_uji_01",
                        "field": "field-name-D",
                        "color": "green"
                      },
                      {
                        "dataset": "pw_uji_01",
                        "field": "field-name-F",
                        "color": "green"
                      }
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "XXXX02",
                "dashboard_name": "圧力",
                "graphs": [
                  {
                    "name": "001 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {
                        "dataset": "pw_uji_01",
                        "field": "field-name-A",
                        "color": "red"
                      },
                      {
                        "dataset": "pw_uji_01",
                        "field": "field-name-B",
                        "color": "blue"
                      },
                      {
                        "dataset": "pw_uji_01",
                        "field": "field-name-C",
                        "color": "green"
                      }
                    ]
                  },
                  {
                    "name": "002 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {
                        "dataset": "pw_uji_01",
                        "field": "field-name-A",
                        "color": "red"
                      },
                      {
                        "dataset": "pw_uji_01",
                        "field": "field-name-B",
                        "color": "blue"
                      },
                      {
                        "dataset": "pw_uji_01",
                        "field": "field-name-C",
                        "color": "green"
                      }
                    ]
                  }
                ]
              }
            ]`
            ,
            "site_id": 1,
            "site_name": "蔵王工場",
            "dataset_id_list": [
              "pw_uji_01"
            ]
        },
        {
            "id": 2,
            "name": "移動脱水車 1 系統",
            "image": "",
            "specification": null,
            "construction_memo": null,
            "organization_code": "4",
            "organization_name": "島根県水道局",
            "facility_group_code": null,
            "plant_id": 2,
            "plant_name": "移動脱水車",
            "dashboard_settings": `[
              {
                "dashboard_id": "001",
                "dashboard_name": "レベル・温度・圧力",
                "graphs": [
                  {
                    "name": "脱炭酸塔レベル計 mm",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_dct_L001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_dct_L001_s2"
                      }
                    ]
                  },
                  {
                    "name": "純水槽レベル計 m",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_pwt_L001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_pwt_L001_s2"
                      }
                    ]
                  },
                  {
                    "name": "No.1活性炭塔温度計 ℃",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_act_T001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_act_T002_s1"
                      }
                    ]
                  },
                  {
                    "name": "No.2活性炭塔温度計 ℃",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_act_T001_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_act_T002_s2"
                      }
                    ]
                  },
                  {
                    "name": "再生水温度計 ℃",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rew_T001_s1"
                      }
                    ]
                  },
                  {
                    "name": "ｱﾆｵﾝ塔出口温度計 ℃",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_art_T001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_art_T001_s2"
                      }
                    ]
                  },
                  {
                    "name": "純水槽温度計 ℃",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_pwt_T002_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_pwt_T003_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_pwt_T001_s1"
                      }
                    ]
                  },
                  {
                    "name": "ﾚｼﾞﾝｷｬｯﾁｬｰ圧力 MPa",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rc_P001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rc_P001_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rc_P002_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rc_P002_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rc_P003_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rc_P003_s2"
                      }
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "002",
                "dashboard_name": "通薬量・積算値",
                "graphs": [
                  {
                    "name": "薬品積算流量計　積算値 L",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_hcl_FQ001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_naoh_FQ001_s1"
                      }
                    ]
                  },
                  {
                    "name": "活性炭塔入口流量計　積算値 m3",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_FQ002_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_FQ002_s2"
                      }
                    ]
                  },
                  {
                    "name": "再生水・処理水積算流量計　積算値 m3",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rew_FQ001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_tw_FQ002_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_tw_FQ002_s2"
                      }
                    ]
                  },
                  {
                    "name": "純水槽水流量計（缶調合）　積算値 m3",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_pwt_FQ001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_pwt_FQ001_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_pwt_FQ001_s3"
                      }
                    ]
                  },
                  {
                    "name": "No.1再生塩酸通薬量 L",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_hcl_FQ002_s1_SV"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_hcl_FQ003_s1_SV"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_hcl_FQ002_s1"
                      }
                    ]
                  },
                  {
                    "name": "No.2再生塩酸通薬量 L",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_hcl_FQ002_s2_SV"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_hcl_FQ003_s2_SV"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_hcl_FQ002_s2"
                      }
                    ]
                  },
                  {
                    "name": "No.1再生苛性通薬量 L",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_naoh_FQ002_s1_SV"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_naoh_FQ003_s1_SV"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_naoh_FQ002_s1"
                      }
                    ]
                  },
                  {
                    "name": "No.2再生苛性通薬量 L",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_naoh_FQ002_s2_SV"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_naoh_FQ003_s2_SV"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_naoh_FQ002_s2"
                      }
                    ]
                  },
                  {
                    "name": "薬品流量計 L/min",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_hcl_F001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_naoh_F001_s1"
                      }
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "003",
                "dashboard_name": "導電率",
                "graphs": [
                  {
                    "name": "原水導電率計 μS/cm",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_X001_s1"
                      }
                    ]
                  },
                  {
                    "name": "ｱﾆｵﾝ塔出口導電率計 μS/cm",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_art_X001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_art_X001_s2"
                      }
                    ]
                  },
                  {
                    "name": "No.1カチオン樹脂センサー μS/cm",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_crs_X001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_crs_X002_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_crs_X003_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_crs_X004_s1"
                      }
                    ]
                  },
                  {
                    "name": "No.2カチオン樹脂センサー μS/cm",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_crs_X001_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_crs_X002_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_crs_X003_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_crs_X004_s2"
                      }
                    ]
                  },
                  {
                    "name": "No.1ｱﾆｵﾝ樹脂センサー μS/cm",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_ars_X001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_ars_X002_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_ars_X003_s1"
                      }
                    ]
                  },
                  {
                    "name": "No.2ｱﾆｵﾝ樹脂センサー μS/cm",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_ars_X001_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_ars_X002_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_ars_X003_s2"
                      }
                    ]
                  },
                  {
                    "name": "純水槽出口導電率計 μS/cm",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_pwt_X001_s1"
                      }
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "004",
                "dashboard_name": "採水量・負荷量",
                "graphs": [
                  {
                    "name": "No.1採水量・通水量 m3",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_tw_FQ001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_FQ001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_tw_FQ001_s1_SV"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_FQ001_s1_SV"
                      }
                    ]
                  },
                  {
                    "name": "No.2採水量・通水量 m3",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_tw_FQ001_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_FQ001_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_tw_FQ001_s2_SV"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_FQ001_s2_SV"
                      }
                    ]
                  },
                  {
                    "name": "No.1ｱﾆｵﾝ負荷量・ｶﾁｵﾝ負荷量 kg-CaCO3",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_XQ001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_XQ002_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_XQ001_s1_SV"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_XQ002_s1_SV"
                      }
                    ]
                  },
                  {
                    "name": "No.2ｱﾆｵﾝ負荷量・ｶﾁｵﾝ負荷量 kg-CaCO3",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_XQ001_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_XQ002_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_XQ001_s2_SV"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_XQ002_s2_SV"
                      }
                    ]
                  },
                  {
                    "name": "ｼﾘｶ負荷量 kg-CaCO3",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_XQ003_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_XQ003_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_XQ003_s1_SV"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rw_XQ003_s2_SV"
                      }
                    ]
                  },
                  {
                    "name": "水系統流量計 m3/h",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_act_F001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_act_F001_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_tw_F001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_tw_F001_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_rew_F001_s1"
                      }
                    ]
                  },
                  {
                    "name": "純水槽送水流量計（缶調合） m3/h",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_pwt_F001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_pwt_F001_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_pwt_F001_s3"
                      }
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "005",
                "dashboard_name": "開度",
                "graphs": [
                  {
                    "name": "脱炭酸塔流入弁 ％",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_dct_V001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_dct_V001_s2"
                      }
                    ]
                  },
                  {
                    "name": "蒸気調節弁 ％",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_vapor_V001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_vapor_V002_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_vapor_V003_s1"
                      }
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "006",
                "dashboard_name": "指示パネル",
                "graphs": [
                  {
                    "name": "再生回数表示",
                    "fields": [
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_X001_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_X002_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_X003_s1"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_X001_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_X002_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_X003_s2"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_X004_s1_SV"
                      },
                      {
                        "dataset": "gw-005",
                        "field": "saiforce_X004_s2_SV"
                      }
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "007",
                "dashboard_name": "変曲点採水量",
                "graphs": [
                  {
                    "name": "No1.カチオン変曲点採水量表示",
                    "fields": [
                      {
                        "dataset": "gw-005--ex",
                        "field": "saiforce_crs-ex_FQ001_s1"
                      },
                      {
                        "dataset": "gw-005--ex",
                        "field": "saiforce_crs-ex_FQ002_s1"
                      },
                      {
                        "dataset": "gw-005--ex",
                        "field": "saiforce_crs-ex_FQ003_s1"
                      },
                      {
                        "dataset": "gw-005--ex",
                        "field": "saiforce_crs-ex_FQ004_s1"
                      }
                    ]
                  },
                  {
                    "name": "No2.カチオン変曲点採水量表示",
                    "fields": [
                      {
                        "dataset": "gw-005--ex",
                        "field": "saiforce_crs-ex_FQ001_s2"
                      },
                      {
                        "dataset": "gw-005--ex",
                        "field": "saiforce_crs-ex_FQ002_s2"
                      },
                      {
                        "dataset": "gw-005--ex",
                        "field": "saiforce_crs-ex_FQ003_s2"
                      },
                      {
                        "dataset": "gw-005--ex",
                        "field": "saiforce_crs-ex_FQ004_s2"
                      }
                    ]
                  },
                  {
                    "name": "No1.アニオン変曲点採水量表示",
                    "fields": [
                      {
                        "dataset": "gw-005--ex",
                        "field": "saiforce_ars-ex_FQ001_s1"
                      },
                      {
                        "dataset": "gw-005--ex",
                        "field": "saiforce_ars-ex_FQ002_s1"
                      },
                      {
                        "dataset": "gw-005--ex",
                        "field": "saiforce_ars-ex_FQ003_s1"
                      }
                    ]
                  },
                  {
                    "name": "No2.アニオン変曲点採水量表示",
                    "fields": [
                      {
                        "dataset": "gw-005--ex",
                        "field": "saiforce_ars-ex_FQ001_s1"
                      },
                      {
                        "dataset": "gw-005--ex",
                        "field": "saiforce_ars-ex_FQ002_s1"
                      },
                      {
                        "dataset": "gw-005--ex",
                        "field": "saiforce_ars-ex_FQ003_s1"
                      }
                    ]
                  }
                ]
              }
            ]`,
            "site_id": 2,
            "site_name": "S 浄化センター",
            "dataset_id_list": [
              "gw-005",
              "gw-005-bit"
            ]
        },
        {
            "id": 3,
            "name": "移動脱水車 2 系統",
            "image": "",
            "specification": null,
            "construction_memo": null,
            "organization_code": "4",
            "organization_name": "島根県水道局",
            "facility_group_code": null,
            "plant_id": 2,
            "plant_name": "移動脱水車",
            "dashboard_settings": `[
              {
                "dashboard_id": "001",
                "dashboard_name": "流量",
                "graphs": [
                  {
                    "name": "2系膜透過水、FMフィルタ流量計 m3/h",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_F002_s2"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_F003_s2"
                      }
                    ]
                  },
                  {
                    "name": "既設第3排水 流量 m3/h",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_F005_s3"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_F007_s3"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_F006_s3"
                      }
                    ]
                  },
                  {
                    "name": "3系膜透過水、FMフィルタ流量計 m3/h",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_F002_s3"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_F003_s3"
                      }
                    ]
                  },
                  {
                    "name": "既設第2排水 流量 m3/h",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_F005_s2"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_F006_s2"
                      }
                    ]
                  },
                  {
                    "name": "1系移送ポンプ流量計 m3/h",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_F001_s1"
                      }
                    ]
                  },
                  {
                    "name": "放流水流量計 m3/h",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_F004_s1"
                      }
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "100",
                "dashboard_name": "圧力",
                "graphs": [
                  {
                    "name": "膜吸引ポンプ圧力計 kPa",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_P001_s2"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_P001_s3"
                      }
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "200",
                "dashboard_name": "水質",
                "graphs": [
                  {
                    "name": "6ﾗｲﾝ流入水BOD計(BOD, SS, COD)",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_rw_X001_s1"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_rw_X002_s1"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_rw_X003_s1"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_rw_X101_s1"
                      }
                    ]
                  },
                  {
                    "name": "Brix計",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_birx_X001_s1"
                      }
                    ]
                  },
                  {
                    "name": "Brix温度",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_birx_T001_s1"
                      }
                    ]
                  },
                  {
                    "name": "6ﾗｲﾝpH計pH",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_ph_X001_s1"
                      }
                    ]
                  },
                  {
                    "name": "6ﾗｲﾝpH計温度 ℃",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_ph_T001_s1"
                      }
                    ]
                  },
                  {
                    "name": "原水調整槽TOC計",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_rw_X004_s1"
                      }
                    ]
                  },
                  {
                    "name": "MLSS計",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_mlss_X001_s1"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_mlss_X001_s2"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_mlss_X001_s3"
                      }
                    ]
                  },
                  {
                    "name": "既設第1設備ph",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_ph_X002_s1"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_ph_X003_s1"
                      }
                    ]
                  },
                  {
                    "name": "好気槽DO",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_rw_X005_s2"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_rw_X005_s3"
                      }
                    ]
                  },
                  {
                    "name": "既設第3設備ph",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_ph_X002_s3"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_ph_X003_s3"
                      }
                    ]
                  },
                  {
                    "name": "既設第2設備ph",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_ph_X002_s2"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_ph_X003_s2"
                      }
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "300",
                "dashboard_name": "水位",
                "graphs": [
                  {
                    "name": "原水調整槽 水位 m",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_rw_L001_s1"
                      }
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "400",
                "dashboard_name": "弁開度",
                "graphs": [
                  {
                    "name": "第2排水 弁開度 ％",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_V003_s1"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_V004_s1"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_V005_s1"
                      }
                    ]
                  },
                  {
                    "name": "第3排水 弁開度 ％",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_V006_s1"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_V007_s1"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_V008_s1"
                      }
                    ]
                  },
                  {
                    "name": "原水調整槽送水弁, 流量調整槽調整弁_弁開度 %",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_V001_s1"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_V002_s1"
                      }
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "500",
                "dashboard_name": "CIP",
                "graphs": [
                  {
                    "name": "CIP1系統 工程情報",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_cip_X003_s1"
                      }
                    ]
                  },
                  {
                    "name": "CIP2系統 工程情報",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_cip_X003_s2"
                      }
                    ]
                  },
                  {
                    "name": "CIP1系統 ライン選択、運転状況",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_cip_X001_s1"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_cip_X002_s1"
                      }
                    ]
                  },
                  {
                    "name": "CIP2系統 ライン選択、運転状況",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "mbr_cip_X001_s2"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "mbr_cip_X002_s2"
                      }
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "600",
                "dashboard_name": "製造品目",
                "graphs": [
                  {
                    "name": "色度計",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "W7B5"
                      },
                      {
                        "dataset": "gw-001",
                        "field": "W7B6"
                      }
                    ]
                  },
                  {
                    "name": "PAC注入ﾎﾟﾝﾌﾟ周波数指令",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "W7B7"
                      }
                    ]
                  },
                  {
                    "name": "品種番号_ASP調合",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "W500"
                      }
                    ]
                  },
                  {
                    "name": "品種番号_SSD調合",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "W510"
                      }
                    ]
                  },
                  {
                    "name": "品種番号_溶解",
                    "fields": [
                      {
                        "dataset": "gw-001",
                        "field": "W520"
                      }
                    ]
                  }
                ]
              }
            ]`,
            "site_id": 2,
            "site_name": "S 浄化センター",
            "dataset_id_list": [
              "pw_uji_01"
            ]
        },
        {
            "id": 4,
            "name": "移動脱水車 3 系統",
            "image": "",
            "specification": null,
            "construction_memo": null,
            "organization_code": "4",
            "organization_name": "島根県水道局",
            "facility_group_code": null,
            "plant_id": 2,
            "plant_name": "移動脱水車",
            "dashboard_settings": `[
              {
                "dashboard_id": "XXXX01",
                "dashboard_name": "流量",
                "graphs": [
                  {
                    "name": "001 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  },
                  {
                    "name": "濃縮水移送流量計",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "XXXX02",
                "dashboard_name": "圧力",
                "graphs": [
                  {
                    "name": "001 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  },
                  {
                    "name": "002 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  }
                ]
              }
            ]`,
            "site_id": 2,
            "site_name": "S 浄化センター",
            "dataset_id_list": [
              "pw_uji_01"
            ]
        },
        {
            "id": 5,
            "name": "排水処理",
            "image": "",
            "specification": null,
            "construction_memo": null,
            "organization_code": "5",
            "organization_name": "TK 大学",
            "facility_group_code": null,
            "plant_id": 3,
            "plant_name": "排水処理",
            "dashboard_settings": `[
              {
                "dashboard_id": "XXXX01",
                "dashboard_name": "流量",
                "graphs": [
                  {
                    "name": "001 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  },
                  {
                    "name": "濃縮水移送流量計",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "XXXX02",
                "dashboard_name": "圧力",
                "graphs": [
                  {
                    "name": "001 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  },
                  {
                    "name": "002 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  }
                ]
              }
            ]`,
            "site_id": 3,
            "site_name": "TK 大学",
            "dataset_id_list": [
              "pw_uji_01"
            ]
        },
        {
            "id": 6,
            "name": "用水処理処理 RO",
            "image": "",
            "specification": null,
            "construction_memo": null,
            "organization_code": "6",
            "organization_name": "A 社",
            "facility_group_code": "RO",
            "facility_group_name": "RO",
            "plant_id": 4,
            "plant_name": "用水処理",
            "dashboard_settings": `[
              {
                "dashboard_id": "XXXX01",
                "dashboard_name": "流量",
                "graphs": [
                  {
                    "name": "001 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  },
                  {
                    "name": "濃縮水移送流量計",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "XXXX02",
                "dashboard_name": "圧力",
                "graphs": [
                  {
                    "name": "001 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  },
                  {
                    "name": "002 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  }
                ]
              }
            ]`,
            "site_id": 4,
            "site_name": "名古屋工場",
            "dataset_id_list": [
              "pw_uji_01"
            ]
        },
        {
            "id": 7,
            "name": "用水処理 SaiForce",
            "image": "",
            "specification": null,
            "construction_memo": null,
            "organization_code": "3",
            "organization_name": "S 社",
            "facility_group_code": "SaiForce",
            "facility_group_name": "SaiForce",
            "plant_id": 5,
            "plant_name": "用水処理",
            "dashboard_settings": `[
              {
                "dashboard_id": "XXXX01",
                "dashboard_name": "流量",
                "graphs": [
                  {
                    "name": "001 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  },
                  {
                    "name": "濃縮水移送流量計",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "XXXX02",
                "dashboard_name": "圧力",
                "graphs": [
                  {
                    "name": "001 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  },
                  {
                    "name": "002 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  }
                ]
              }
            ]`,
            "site_id": 5,
            "site_name": "宇治川工場",
            "dataset_id_list": [
              "pw_uji_01"
            ]
        },
        {
            "id": 8,
            "name": "用水処理 SaiForce",
            "image": "",
            "specification": null,
            "construction_memo": null,
            "organization_code": "3",
            "organization_name": "S 社",
            "facility_group_code": "SaiForce",
            "facility_group_name": "SaiForce",
            "plant_id": 6,
            "plant_name": "用水処理",
            "dashboard_settings": `[
              {
                "dashboard_id": "XXXX01",
                "dashboard_name": "流量",
                "graphs": [
                  {
                    "name": "001 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  },
                  {
                    "name": "濃縮水移送流量計",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "XXXX02",
                "dashboard_name": "圧力",
                "graphs": [
                  {
                    "name": "001 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  },
                  {
                    "name": "002 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  }
                ]
              }
            ]`,
            "site_id": 6,
            "site_name": "多摩川工場",
            "dataset_id_list": [
              "pw_uji_01"
            ]
        },
        {
            "id": 9,
            "name": "排水処理 SaiForce",
            "image": "",
            "specification": null,
            "construction_memo": null,
            "organization_code": "2",
            "organization_name": "C 社",
            "facility_group_code": "SaiForce",
            "facility_group_name": "SaiForce",
            "plant_id": 7,
            "plant_name": "用水処理",
            "dashboard_settings": `[
              {
                "dashboard_id": "XXXX01",
                "dashboard_name": "流量",
                "graphs": [
                  {
                    "name": "001 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  },
                  {
                    "name": "濃縮水移送流量計",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "XXXX02",
                "dashboard_name": "圧力",
                "graphs": [
                  {
                    "name": "001 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  },
                  {
                    "name": "002 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  }
                ]
              }
            ]`,
            "site_id": 1,
            "site_name": "蔵王工場",
            "dataset_id_list": [
              "pw_uji_01"
            ]
        },
        {
            "id": 10,
            "name": "排水処理 MBR",
            "image": "",
            "specification": null,
            "construction_memo": null,
            "organization_code": "7",
            "organization_name": "P 社",
            "facility_group_code": "MBR",
            "facility_group_name": "MBR",
            "plant_id": 8,
            "plant_name": "排水処理",
            "dashboard_settings": `[
              {
                "dashboard_id": "XXXX01",
                "dashboard_name": "流量",
                "graphs": [
                  {
                    "name": "001 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  },
                  {
                    "name": "濃縮水移送流量計",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  }
                ]
              },
              {
                "dashboard_id": "XXXX02",
                "dashboard_name": "圧力",
                "graphs": [
                  {
                    "name": "001 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  },
                  {
                    "name": "002 RO ユニット流量 m/s",
                    "dataset_id": "pw_uji_01",
                    "fields": [
                      {"dataset": "pw_uji_01", "field": "field-name-A", "color":"red"},
                      {"dataset": "pw_uji_01", "field": "field-name-B", "color":"blue"},
                      {"dataset": "pw_uji_01", "field": "field-name-C", "color":"green"}
                    ]
                  }
                ]
              }
            ]`,
            "site_id": 7,
            "site_name": "群馬工場",
            "dataset_id_list": [
              "pw_uji_01"
            ]
        }
    ]),
    )
  }),
  /**
   * 設備詳細情報
   */
  rest.get('/swc-api/master/nodes/:node_id', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json({
        "id": 1,
        "name": "排水処理 MBR",
        "image": "",
        "specification": null,
        "construction_memo": null,
        "organization_code": "2",
        "organization_name": "C 社",
        "facility_group_code": "MBR",
        "facility_group_name": "MBR",
        "plant_id": 1,
        "plant_name": "排水処理",
        "dashboard_settings": null,
        "site_id": 1,
        "site_name": "蔵王工場",
        "description": "テストテストテストテストテスト",
        "notify_to_admin": [
          "admin1@admin.co.jp",
          "admin2@admin.co.jp"
        ],
        "notify_to_user": [
          "user1@user.co.jp",
          "user2@user.co.jp"
        ],
        "construction_infomation": "テストテストテストテストテスト",
        "installed_date": "2022-01-12",
      }),
    )
  }),
  /**
   * 設備情報更新（一部）
   */
  rest.patch('/swc-api/master/nodes/:nodeId', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    const dummy = {
      "id": 1,
      "name": "排水処理 MBR",
      "image": "",
      "specification": null,
      "construction_memo": null,
      "organization_code": "2",
      "organization_name": "C 社",
      "facility_group_code": "MBR",
      "facility_group_name": "MBR",
      "plant_id": 1,
      "plant_name": "排水処理",
      "dashboard_settings": null,
      "site_id": 1,
      "site_name": "蔵王工場",
      "description": "テストテストテストテストテスト",
      "notify_to_admin": [
        "admin1@admin.co.jp",
        "admin2@admin.co.jp"
      ],
      "notify_to_user": [
        "user1@user.co.jp",
        "user2@user.co.jp"
      ],
      "construction_infomation": "テストテストテストテストテスト",
      "installed_date": "2022-01-12",
    }

    return res(
      ctx.status(200),
      ctx.json(Object.assign(dummy,req.body)),
    )
  }),
  /**
   * 設備情報新規登録
   */
  rest.post('/swc-api/master/nodes', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),
  /**
   * 設備情報更新
   */
  rest.put('/swc-api/master/nodes/:nodeId', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),
  /**
   * 設備情報削除
   */
  rest.delete('/swc-api/master/nodes/:nodeId', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),
]
